/**
 * Injects account-level custom modules (scripts/styles) into the page.
 * Modules are stored in crm_configs.config.modules per account.
 */

const DANGEROUS_CSS_PATTERNS = [
  /pointer-events\s*:\s*none/i,
  /display\s*:\s*none/i,
  /opacity\s*:\s*0(?:[;\s}]|$)/i,
  /visibility\s*:\s*hidden/i,
];

function isSafeCSS(code) {
  return !DANGEROUS_CSS_PATTERNS.some(pattern => pattern.test(code));
}

export function injectAccountModules(modules) {
  // Remove previously injected modules
  document.querySelectorAll('[data-account-module]').forEach(el => el.remove());

  if (!Array.isArray(modules)) return;

  modules.forEach(mod => {
    if (!mod.active || !mod.code) return;

    if (mod.type === 'style') {
      if (!isSafeCSS(mod.code)) {
        // eslint-disable-next-line no-console
        console.warn(
          `[accountModules] Blocked potentially dangerous CSS module: ${mod.name}`
        );
        return;
      }
      const style = document.createElement('style');
      style.setAttribute('data-account-module', mod.id || mod.name);
      style.setAttribute('data-module-name', mod.name);
      style.textContent = mod.code;
      document.head.appendChild(style);
    } else {
      const script = document.createElement('script');
      script.setAttribute('data-account-module', mod.id || mod.name);
      script.setAttribute('data-module-name', mod.name);
      script.textContent = mod.code;
      document.head.appendChild(script);
    }
  });
}

export function clearAccountModules() {
  document.querySelectorAll('[data-account-module]').forEach(el => el.remove());
}
